import { Fragment, useEffect, useRef, useState } from "react";
import InfiniteScrollGrid from "../../UI/infinite-scroll-grid";
import {
  ImageNameCellRenderer,
  MoreOptionsRenderer,
  NameCellRenderer,
  StudioStatusCellRenderer,
  StudioTrainingStatusCellRenderer,
} from "../../UI/grid-cells";

interface Option {
  label: string;
  icon: string;
}

function ExploreGrid({
  selectedColumns,
  rowSelection,
  moreOptions,
  handleEdit,
  handleDelete,
  rowData,
  scrollGroundRef,
  handleScroll,
  initialLoading,
  isLoading,
  limit,
  finalFetch,
  sorting,
  sortingColumnName,
  handleSort,
  noDataFound,
  handleClick,
}: any) {
  const [columnDefs, setColumnDefs] = useState<any>([
    {
      headerName: "Magic Name",
      token: "web.magix.label.magicname",
      field: "name",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Magic Description",
      token: "web.magix.label.magicdescription",
      field: "description",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Created Date",
      token: "web.common.label.createddate",
      field: "createdAt",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Status",
      token: "web.common.label.status",
      field: "statusId",
      width: "flex-1",
      align: "left",
    },
    {
      headerName: "Training Status",
      token: "Training Status",
      field: "iterationStatusId",
      width: "flex-1",
      align: "left",
    },
  ]);

  const selectedMoreOption = (option: string, row: any) => {
    if (option === "edit") {
      handleEdit(row);
    } else {
      handleDelete(row);
    }
  };

  return (
    <div className="w-full h-full mt-8">
      <InfiniteScrollGrid
        columnDefs={columnDefs}
        rowData={rowData}
        initialLoading={initialLoading}
        searchedQuery=""
        handleScroll={handleScroll}
        chatGroundRef={scrollGroundRef}
        selectedColumns={selectedColumns}
        isLoading={isLoading}
        finalFetch={finalFetch}
        rowSelection={rowSelection}
        moreOptions={moreOptions}
        handleSort={handleSort}
        sorting={sorting}
        sortingColumnName={sortingColumnName}
        noDataFound={noDataFound}
      >
        {rowData?.map((rowData: any, i: number) => (
          <Fragment key={i}>
            <tr className="w-full h-auto flex justify-between p-[0.65rem] border-b border-[#EDEDED] hover:bg-[#eff8ff] dark:hover:bg-[#112A46]">
              {/* <RowSelectionRenderer
                    rowData={rowData}
                    rowSelection={rowSelection}
                    handleCheckboxChange={handleCheckboxChange}
                  /> */}
              <ImageNameCellRenderer
                cellKey="name"
                selectedColumns={selectedColumns}
                rowData={rowData}
                imageType="card"
              />
              <NameCellRenderer
                cellKey="description"
                selectedColumns={selectedColumns}
                rowData={rowData}
              />
              <NameCellRenderer
                cellKey="createdAt"
                selectedColumns={selectedColumns}
                rowData={rowData}
              />
              <StudioStatusCellRenderer
                cellKey="statusId"
                selectedColumns={selectedColumns}
                rowData={rowData}
              />

               <StudioTrainingStatusCellRenderer
                cellKey="iterationStatusId"
                selectedColumns={selectedColumns}
                rowData={rowData}
                handleClick={handleClick}
              />
              
              <MoreOptionsRenderer
                rowData={rowData}
                moreOptions={moreOptions}
                selectedMoreOption={selectedMoreOption}
              />
            </tr>
          </Fragment>
        ))}
      </InfiniteScrollGrid>
    </div>
  );
}

export default ExploreGrid;
